import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { ArrowLeft, Printer, ChevronRight } from "lucide-react";
import { InvoiceDoc } from "@/pages/InvoiceCreate";

export default function InvoiceView() {
  const { id } = useParams();
  const [inv, setInv] = useState(null);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get(`/invoices/${id}`); setInv(data); }
      catch (e) { toast.error(apiError(e)); }
    })();
  }, [id]);

  if (!inv) return <div className="text-slate-500">Loading invoice…</div>;

  return (
    <div className="space-y-6 print:space-y-0">
      <div className="flex items-center justify-between gap-3 print:hidden">
        <div className="flex items-center gap-2 text-sm">
          <Link to={`/projects/${inv.project_id}`} className="text-slate-500 hover:text-brandblue inline-flex items-center gap-1" data-testid="link-back-project">
            <ArrowLeft className="h-4 w-4" /> {inv.project_name}
          </Link>
          <ChevronRight className="h-3.5 w-3.5 text-slate-300" />
          <span className="text-slate-700 font-medium">{inv.invoice_number}</span>
        </div>
        <Button onClick={() => window.print()} className="h-11 bg-brandblue hover:bg-brandblue-hover text-white" data-testid="btn-print-invoice">
          <Printer className="h-4 w-4" /> Print / PDF
        </Button>
      </div>
      <InvoiceDoc inv={inv} />
      <style>{`@media print { @page { size:A4; margin:12mm } body { background:white } nav, header.sticky, .print\\:hidden { display:none !important } main { padding:0 !important; max-width:100% !important } }`}</style>
    </div>
  );
}
